import React from 'react'
import {useParams} from 'react-router-dom'
import {useGetWithdrawByIdQuery} from '../../../features/withdraws/withdrawSlice'
import {Loader} from '../../../shared/Loader'
import {WithdrawalType} from "./types";

export const WithdrawDetails = () => {
  let { id } = useParams()

  const {
    data: withdraw,
    isLoading,
    isFetching,
    isError,
  } = useGetWithdrawByIdQuery(id)

  return (
    <div className='font-dashboard pt-4 pb-12 md:px-4 min-h-screen'>
      <div className='max-w-[700px] mx-auto relative'>
        <div className='bg-black flex flex-col gap-4 px-4 lg:px-10 py-10 min-h-[85vh]'>
          <h3 className='text-2xl text-white'>Withdraw Details</h3>
          <hr className='border-white/10' />

          {isLoading || isFetching ? (
            <div className='w-full h-[70vh] flex justify-center items-center'>
              <Loader />
            </div>
          ) : (
            <>
              <table className='flex flex-col gap-2'>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Transaction ID</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?._id}
                  </td>
                </tr>

                {/* NIBSS session id — the reference the bank can trace. PalmPay / Nomba
                    report it; Breet, manual and legacy payouts never do, so hide the row. */}
                {withdraw?.providerSessionId && (
                  <tr>
                    <td className='w-[200px]'>
                      <p className='text-base text-white/70'>Session ID</p>
                    </td>
                    <td className='text-sm font-light text-white/40'>
                      <span className='inline-flex items-center gap-2'>
                        <span className='font-mono break-all'>{withdraw.providerSessionId}</span>
                        <button
                          type='button'
                          aria-label='Copy session ID'
                          className='rounded border border-white/20 px-2 py-0.5 text-xs text-white/70 hover:bg-white/10'
                          onClick={() => navigator.clipboard?.writeText(withdraw.providerSessionId)}
                        >
                          Copy
                        </button>
                      </span>
                    </td>
                  </tr>
                )}

                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Placed By</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.user?.name}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Type</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.type}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Withdrawal Type</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.withdrawalType}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Narration</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.narration || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Source</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.source || "account"}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Amount</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.amount}
                  </td>
                </tr>
                <div className="text-white py-3">Withdrawal Method</div>

                {
                  withdraw?.withdrawalType === WithdrawalType.QuickMobile ? (
                      <>

                      </>
                  ) : withdraw?.withdrawalType === WithdrawalType.QuickCrypto ? (
                      <>
                        <tr>
                          <td className='w-[200px]'>
                            <p className='text-base text-white/70'>Coin</p>
                          </td>
                          <td className='text-sm font-light text-white/40'>
                            {withdraw?.coin || withdraw?.withdrawalDetails?.split(":")?.[0]}
                          </td>
                        </tr>

                      </>
                  ) : (
                      <>
                        <tr>
                          <td className='w-[200px]'>
                            <p className='text-base text-white/70'>Bank Name</p>
                          </td>
                          <td className='text-sm font-light text-white/40'>
                            {withdraw?.bank?.bankName}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-[200px]'>
                            <p className='text-base text-white/70'>Account Name</p>
                          </td>
                          <td className='text-sm font-light text-white/40'>
                            {withdraw?.bank?.accountName}
                          </td>
                        </tr>
                        <tr>
                          <td className='w-[200px]'>
                            <p className='text-base text-white/70'>Account Number</p>
                          </td>
                          <td className='text-sm font-light text-white/40'>
                            {`${withdraw?.bank?.accountNumber.substring(
                                0,
                                2
                            )}*****${withdraw?.bank?.accountNumber
                                ?.toString()
                                ?.substring(withdraw?.bank?.accountNumber?.length - 4)}`}
                          </td>
                        </tr>
                      </>
                  )
                }

                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Withdrawal Details</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.withdrawalDetails}
                  </td>
                </tr>


                <div className="text-white py-3">Withdrawal Status</div>

                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Status</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.status}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Created At</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.createdAt}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Updated At</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.updatedAt}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Note</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.note}
                  </td>
                </tr>
                <tr>
                  <td className='w-[200px]'>
                    <p className='text-base text-white/70'>Comment</p>
                  </td>
                  <td className='text-sm font-light text-white/40'>
                    {withdraw?.comment}
                  </td>
                </tr>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
